import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import React from "react"
import { useTranslation } from "react-i18next"
import { setShowObservacionesModal } from "../../redux/slices/newDocumentoSettingsSlice"
import { ButtonAction } from "../ConceptosTable"

const DocumentoFormOnservaciones = ({
  observacionCesion,
  observaciones,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { colorSelected, showObservaciones } = useSelector(
    newDocumentoSettingsSelector
  )

  const dispatch = useDispatch()

  return showObservaciones || observacionCesion ? (
    <div className='border-0 card'>
      <div
        style={{ backgroundColor: colorSelected }}
        className='card-header header-blue d-flex align-items-center justify-content-between'
      >
        {t("crear.facturaRec.remarksLabel")}
        <ButtonAction
          style={{ color: "white", zIndex: "10" }}
          // @ts-expect-error TS(2345): Argument of type...
          onClick={() => dispatch(setShowObservacionesModal(true))}
          iconName='pen'
          className='tx-white'
        />
      </div>

      <div className='p-1 card-body'>
        {observacionCesion && (
          <p className='mt-2 text-left'>{observacionCesion}</p>
        )}

        <p className='mt-2 text-left'>
          {observaciones
            .split("\n")
            .map(
              (
                line: $TSMigrationFixMe,
                index: $TSMigrationFixMe,
                array: $TSMigrationFixMe
              ) => (
                <React.Fragment key={line}>
                  {line}
                  {index !== array.length - 1 && <br />}
                </React.Fragment>
              )
            )}
        </p>
      </div>
    </div>
  ) : null
}

export default DocumentoFormOnservaciones
